export default __webpack_public_path__ + "25e3a95433fb2f8711cea1bdffbbea3f.png";